// Import Slick Carousel
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Collapse, Modal, Ripple, initTWE } from "tw-elements";

(function ($) {
    "use strict";

    $(document).ready(function () {

        /*******************************************/
        /* VARIABLES */
        /*******************************************/

        var mobile_width = 991,
            $window = $(window),
            $body = $('body'),
            $wpcf7 = $('.wpcf7'),
            $expandsub = $('.expand-sub');

        /*******************************************/
        /* HEADER - MOBILE MENU */
        /*******************************************/

        const $hamburger = $('.js-hamburger');
        const $mobileMenu = $('.mobile-menu');
        const $mobileMenuClose = $('.mobile-menu-close');

        function openMobileMenu() {
            $hamburger.addClass('is-active');
            $mobileMenu.addClass('is-active');
            $body.addClass('menu-open');
        }

        function closeMobileMenu() {
            $hamburger.removeClass('is-active');
            $mobileMenu.removeClass('is-active');
            $body.removeClass('menu-open');
        }

        // Hamburger click
        $hamburger.on('click', function() {
            if ($mobileMenu.hasClass('is-active')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        // Close button click
        $mobileMenuClose.on('click', closeMobileMenu);

        /*******************************************/
        /* HEADER - MINI CART */
        /*******************************************/

        const $desktopCartToggle = $('#desktop-cart-toggle');
        const $mobileCartToggle = $('#mobile-cart-toggle');
        const $miniCartSidebar = $('.mini-cart-sidebar');
        const $miniCartClose = $('.mini-cart-close');
        const $miniCartOverlay = $('.mini-cart-overlay');

        // Open cart function
        function openMiniCart() {
            $miniCartSidebar.removeClass('-translate-x-full');
            $miniCartOverlay.removeClass('hidden');
            $body.css('overflow', 'hidden');

            // Загружаем свежий контент корзины
            // $.post(wc_add_to_cart_params.ajax_url, {
            //     action: 'woocommerce_get_refreshed_fragments'
            // }, function(response) {
            //     if (response && response.fragments) {
            //         $.each(response.fragments, function(key, value) {
            //             if (key === 'div.widget_shopping_cart_content') {
            //                 $('.mini-cart-content .widget_shopping_cart_content').replaceWith(value);
            //             }
            //         });
            //     }
            // });
        }

        // Close cart function
        function closeMiniCart() {
            $miniCartSidebar.addClass('-translate-x-full');
            $miniCartOverlay.addClass('hidden');
            $body.css('overflow', '');
        }

        // Desktop cart toggle
        $desktopCartToggle.on('click', function(e) {
            e.preventDefault();
            openMiniCart();
        });

        // Mobile cart toggle
        $mobileCartToggle.on('click', function(e) {
            e.preventDefault();
            openMiniCart();
        });

        // Close cart buttons
        $miniCartClose.on('click', closeMiniCart);
        $miniCartOverlay.on('click', closeMiniCart);

        /*******************************************/
        /* HEADER - SEARCH OVERLAY */
        /*******************************************/

        const $searchWrapper = $('#search-overlay-wrapper');
        const $searchOverlay = $('#search-overlay');
        const $searchBackdrop = $('#search-backdrop');
        const $searchBtn = $('#site-search, #site-search-mobile');
        const $searchCloseBtn = $('#search-close');
    
        // Get scrollbar width
        function getScrollbarWidth() {
            return window.innerWidth - document.documentElement.clientWidth;
        }
    
        // Toggle search (open/close)
        $searchBtn.on('click', function(e) {
            e.preventDefault();
            
            // If already open - close
            if (!$searchWrapper.hasClass('hidden')) {
                closeSearch();
                return;
            }
            
            // Save scrollbar width and add padding
            const scrollbarWidth = getScrollbarWidth();
            $body.css('padding-right', scrollbarWidth + 'px').addClass('overflow-hidden');
            
            // Open
            $searchWrapper.removeClass('hidden');
            setTimeout(() => {
                $searchBackdrop.addClass('opacity-100');
                $searchOverlay.removeClass('-translate-y-full').addClass('translate-y-0');
            }, 10);
        });
    
        // Close search
        function closeSearch() {
            $searchBackdrop.removeClass('opacity-100');
            $searchOverlay.removeClass('translate-y-0').addClass('-translate-y-full');
            setTimeout(() => {
                $searchWrapper.addClass('hidden');
                $body.css('padding-right', '').removeClass('overflow-hidden');
            }, 300);
        }
    
        $searchCloseBtn.on('click', closeSearch);
        $searchBackdrop.on('click', closeSearch);

        /*******************************************/
        /* HEADER - DESKTOP USER DROPDOWN */
        /*******************************************/

        const $desktopUserToggle = $('.header-user-toggle');
        const $desktopUserMenu = $('.header-user-menu');
        const $desktopUserDropdown = $('.header-user-dropdown');

        $desktopUserToggle.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = $desktopUserMenu.hasClass('opacity-100');
            
            if (isOpen) {
                closeDesktopUserMenu();
            } else {
                openDesktopUserMenu();
            }
        });

        function openDesktopUserMenu() {
            $desktopUserMenu.removeClass('opacity-0 invisible').addClass('opacity-100 visible');
            $desktopUserToggle.find('svg').addClass('rotate-180');
        }

        function closeDesktopUserMenu() {
            $desktopUserMenu.removeClass('opacity-100 visible').addClass('opacity-0 invisible');
            $desktopUserToggle.find('svg').removeClass('rotate-180');
        }

        // Close when clicking outside
        $(document).on('click', function(e) {
            if (!$desktopUserDropdown.is(e.target) && $desktopUserDropdown.has(e.target).length === 0) {
                closeDesktopUserMenu();
            }
        });

        /*******************************************/
        /* GLOBAL - ESC KEY HANDLER */
        /*******************************************/

        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') {
                // Close mobile menu
                if ($mobileMenu.hasClass('is-active')) {
                    closeMobileMenu();
                }
                // Close mini cart
                if (!$miniCartSidebar.hasClass('-translate-x-full')) {
                    closeMiniCart();
                }
                // Close search
                if (!$searchWrapper.hasClass('hidden')) {
                    closeSearch();
                }
                // Close desktop user menu
                if ($desktopUserMenu.hasClass('opacity-100')) {
                    closeDesktopUserMenu();
                }
            }
        });

        /*******************************************/
        /* ARCHIVE - MOBILE CATEGORIES SIDEBAR */
        /*******************************************/

        const $mobileCategoryToggle = $('.mobile-category-toggle');
        const $mobileCategoryClose = $('.mobile-category-close');
        const $categoriesSidebar = $('.mobile-categories-sidebar');
        const $categoriesOverlay = $('.mobile-categories-overlay');

        function openCategoriesSidebar() {
            $categoriesSidebar.removeClass('translate-x-full');
            $categoriesOverlay.removeClass('hidden');
            $body.addClass('overflow-hidden');
        }

        function closeCategoriesSidebar() {
            $categoriesSidebar.addClass('translate-x-full');
            $categoriesOverlay.addClass('hidden');
            $body.removeClass('overflow-hidden');
        }

        $mobileCategoryToggle.on('click', openCategoriesSidebar);
        $mobileCategoryClose.on('click', closeCategoriesSidebar);
        $categoriesOverlay.on('click', closeCategoriesSidebar);

        /*******************************************/
        /* SLICK SLIDERS */
        /*******************************************/

        const textDirection = $("html").attr("dir");

        // Homepage Floor 1 Slider (Hero/Banner)
        $('.js-homepage-floor1-slider').slick({
            rtl: true,
            arrows: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            fade: true,
            pauseOnHover: false,
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto text-white"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto text-white"></i>',
        });

        // Footer Slider
        $('.js-footer-slider').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-20 w-auto absolute top-1/2 -translate-y-1/2 align-middle"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-20 w-auto absolute top-1/2 -translate-y-1/2 align-middle"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        // Homepage Floor 3 - Categories Slider
        $('.js-homepage-floor3-categories').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-20 absolute left-0 top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translate(-50%, -50%);"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-20 absolute right-0 top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translate(50%, -50%);"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: 'unslick'
                },
            ]
        });

        // Project Slider (Main + Nav)
        $('.js-project-slider').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            infinite: true,
            asNavFor: '.js-project-slider-nav',
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto pos-l-0 text-white"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto pos-r-0 text-white"></i>',
        });

        $('.js-project-slider-nav').slick({
            rtl: true,
            arrows: false,
            slidesToShow: 5,
            infinite: true,
            slidesToScroll: 1,
            asNavFor: '.js-project-slider',
            dots: false,
            centerMode: true,
            focusOnSelect: true
        });

        // Dynamic Project Sliders (multiple instances)
        $('[class*="js-project-slider-"]:not([class*="-nav"])').each(function() {
            var $mainSlider = $(this);
            var classList = $mainSlider.attr('class').split(' ');
            var sliderClass = '';
            
            // Find class project-slider-X
            for (var i = 0; i < classList.length; i++) {
                if (classList[i].indexOf('project-slider-') !== -1 && classList[i].indexOf('js-') === -1) {
                    sliderClass = classList[i];
                    break;
                }
            }
            
            if (!sliderClass) return;
            
            var $navSlider = $('.' + sliderClass + '-nav');
            
            $mainSlider.slick({
                rtl: true,
                dots: false,
                arrows: true,
                slidesToShow: 1,
                infinite: true,
                asNavFor: $navSlider,
                nextArrow: '<button class="slick-arrow icon-nav-left absolute left-4 top-1/2 -translate-y-1/2 bg-white rounded-full w-12 h-12 flex items-center justify-center z-10"></button>',
                prevArrow: '<button class="slick-arrow icon-nav-right absolute right-4 top-1/2 -translate-y-1/2 bg-white rounded-full w-12 h-12 flex items-center justify-center z-10"></button>',
            });
            
            $navSlider.slick({
                rtl: true,
                arrows: false,
                slidesToShow: 5,
                infinite: true,
                slidesToScroll: 1,
                asNavFor: $mainSlider,
                dots: false,
                centerMode: true,
                focusOnSelect: true
            });
        });

        // Homepage Floor 3 - Categories Slider
        $('.js-related-products').slick({
            rtl: true,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s cursor-pointer z-20 absolute top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translateY(-50%);"></i>',
            prevArrow: '<i class="icon-nav-right icon-s cursor-pointer z-20 absolute top-1/2 text-dark bg-white rounded-full w-12 h-12 flex justify-center items-center slick-arrow" style="transform: translateY(-50%);"></i>',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });

        /*******************************************/
        /* AOS - INIT AFTER SLICK */
        /*******************************************/

        AOS.init({
            offset: 200,
            duration: 1000,
        });

        initTWE({ Collapse, Modal, Ripple });

        /*******************************************/
        /* BLOG */
        /*******************************************/

        $('.blog-cat').on('click', function () {
            $('.blog-cat').removeClass('current-cat');
            $(this).addClass('current-cat');
        });

        $('#post-category-select').on('change', function () {
            location = $(this).val();
        });

        $('#search-id').click(function () {
            $(this).closest('form').submit();
        });

        /*******************************************/
        /* FORMS - CONTACT FORM 7 */
        /*******************************************/

        // Submitting a form - adding a class to indicate loading
        $wpcf7.on('submit', function (e) {
            $(this).closest('.wpcf7').addClass('cf7-sending');
        });

        // Validation error - removing the loading indicator
        $wpcf7.on('invalid.wpcf7', function (e) {
            $(this).closest('.wpcf7').removeClass('cf7-sending');
        });

        // Successful sending with redirect
        document.addEventListener('wpcf7mailsent', function (event) {
            if (event.detail.contactFormId == 2540) return;
            if (event.detail.apiResponse && event.detail.apiResponse.redirect) {
                window.location.href = event.detail.apiResponse.redirect;
            }
        }, false);

        /*******************************************/
        /* FORMS - INPUT PLACEHOLDERS */
        /*******************************************/

        var $inputItem = $(".js-inputWrapper");
        $inputItem.length && $inputItem.each(function() {
            var $this = $(this),
                $input = $this.find(".formRow--input"),
                placeholderTxt = $input.attr("placeholder"),
                $placeholder;
            
            if (typeof placeholderTxt == 'undefined'){
                placeholderTxt = "";
            }

            $input.after('<span class="placeholder">' + placeholderTxt + "</span>"),
                $input.attr("placeholder", ""),
                $placeholder = $this.find(".placeholder"),

                $input.val().length ? $this.addClass("active") : $this.removeClass("active"),

                $input.on("focusout", function() {
                    $input.val().length ? $this.addClass("active") : $this.removeClass("active");
                }).on("focus", function() {
                    $this.addClass("active");
                });
        });

        /*******************************************/
        /* VIDEO POPUP */
        /*******************************************/

        $('.video-cubic').click(function () {
            $(this).html($(this).data('iframe')).css('background', 'none');
        });

        $('.success-video-popup').on('show.bs.modal', function() {
            var modal = $(this);
            var videoContainer = modal.find('.video-cubic');
            var videoUrl = videoContainer.data('video-url');

            if (videoUrl && videoContainer.find('iframe').length === 0) {
                var videoSrc = videoUrl.replace('watch?v=', 'embed/');
                var separator = (videoSrc.indexOf('?') === -1) ? '?' : '&';
                videoSrc += separator + 'feature=oembed&controls=1&hd=1&autohide=1&enablejsapi=1&autoplay=1&rel=0&cc_load_policy=1';

                var iframe = '<iframe width="100%" src="' + videoSrc + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

                videoContainer.html(iframe);
            }
        });

        $('.success-video-popup').on('hide.bs.modal', function() {
            $(this).find('.video-cubic').empty();
        });

        /*******************************************/
        /* FOOTER MENU ACCORDION - MOBILE ONLY */
        /*******************************************/

        $('.js-open-footer-menu').on('click', function() {
            if ($window.width() < 1024) {
                $(this).toggleClass('active');
                $(this).next('.widget-content').toggleClass('active');
            }
        });

        // Remove active class on desktop
        $window.on('resize', function() {
            if ($window.width() >= 1024) {
                $('.js-open-footer-menu').removeClass('active');
                $('.widget-content').removeClass('active');
            }
        });


        /*******************************************/
        /* Smooth woocommerce message */
        /*******************************************/
        var $message = $('.woocommerce-message');
    
        if ($message.length) {
            // Smooth appearance
            setTimeout(function() {
                $message.addClass('show');
            }, 100);
            
            // Smooth disappearance through 3 seconds
            setTimeout(function() {
                $message.removeClass('show').addClass('fade-out');
                
                setTimeout(function() {
                    $message.remove();
                }, 500);
            }, 3000);
        }
        
        // On AJAX adding to cart
        $(document.body).on('added_to_cart', function() {
            // Update cart badge
            $(document.body).trigger('wc_fragment_refresh');
            
            setTimeout(function() {
                var $newMessage = $('.woocommerce-message');
                if ($newMessage.length) {
                    $newMessage.addClass('show');
                    
                    setTimeout(function() {
                        $newMessage.removeClass('show').addClass('fade-out');
                        setTimeout(function() {
                            $newMessage.remove();
                        }, 500);
                    }, 3000);
                }
            }, 100);
        });


        /*******************************************/
        /* PRODUCT TABS ACCORDION - MOBILE */
        /*******************************************/
        
        function initProductTabsAccordion() {
            // Используем делегирование событий на уровне документа для надежности
            $(document).off('click', '.product-tabs-accordion .accordion-header');
            $(document).on('click', '.product-tabs-accordion .accordion-header', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                var $header = $(this);
                var $item = $header.closest('.accordion-item');
                var $accordion = $header.closest('.product-tabs-accordion');
                var $content = $item.find('.accordion-content');
                var $icon = $header.find('.accordion-icon');
                var isExpanded = $header.attr('aria-expanded') === 'true';
                
                // Закрываем все другие открытые элементы перед открытием нового
                if (!isExpanded) {
                    $accordion.find('.accordion-header[aria-expanded="true"]').not($header).each(function() {
                        var $otherHeader = $(this);
                        var $otherItem = $otherHeader.closest('.accordion-item');
                        var $otherContent = $otherItem.find('.accordion-content');
                        var $otherIcon = $otherHeader.find('.accordion-icon');
                        $otherHeader.attr('aria-expanded', 'false');
                        $otherItem.removeClass('active');
                        $otherContent.removeClass('active');
                        $otherIcon.text('+');
                    });
                    
                    // Небольшая задержка перед открытием нового элемента для плавности
                    setTimeout(function() {
                        $header.attr('aria-expanded', 'true');
                        $item.addClass('active');
                        $content.addClass('active');
                        $icon.text('-');
                    }, 50);
                } else {
                    // Закрываем
                    $header.attr('aria-expanded', 'false');
                    $item.removeClass('active');
                    $content.removeClass('active');
                    $icon.text('+');
                }
            });
            
            // Открываем первый таб по умолчанию (опционально)
            // Можно раскомментировать, если нужно открывать первый таб
            // var $firstItem = $accordion.find('.accordion-item').first();
            // if ($firstItem.length) {
            //     var $firstHeader = $firstItem.find('.accordion-header');
            //     $firstHeader.trigger('click');
            // }
        }
        
        // Инициализация при загрузке страницы
        initProductTabsAccordion();
        
        // Инициализация после полной загрузки DOM
        $(window).on('load', function() {
            initProductTabsAccordion();
        });
        
        // Инициализация после AJAX обновления (если используется)
        $(document.body).on('updated_wc_div', function() {
            initProductTabsAccordion();
        });


    });

})(jQuery);